import { Button } from "ui/components/button";
import { Icon } from "components";
import { LOADER2 } from "icons";

export default function ButtonWithLoading({
  isLoading = false,
  children,
  className,
  onClick = () => {},
  variant = "outline",
  disabled = false,
  ...rest
}) {
  function handleClick(e) {
    e.preventDefault();
    if (onClick && !disabled && !isLoading) {
      onClick(e);
    }
  }
  
  return (
    <Button
      variant={variant}
      className={className}
      onMouseDown={handleClick}
      disabled={isLoading || disabled}
      {...rest}
    >
      {isLoading && <Icon icon={LOADER2} className="animate-spin " />}
      {children}
    </Button>
  );
}
